export enum CompetitionType {
  Once = "ONCE",
  Daily = "DAILY",
}

export enum FieldType {
  Text = "TEXT",
  TextArea = "TEXTAREA",
  Number = "NUMBER",
  Date = "DATE"
}

export class FieldItem {
  public name: string;
  public type: FieldType;
  public required: boolean;
  public value: string;

  constructor(values: any) {
    this.name = values.name;
    this.type = values.type;
    this.required = values.required;
    this.value = values.value ?? "";
  }

  get placeholder() {
    if (this.required) {
      return `${this.name}*`
    }
    return `${this.name}`
  }
}



export class Competition {
  public id: string;
  public type: CompetitionType;
  public name: string;
  public description: string;
  public terms: string;
  public start: Date;
  public end: Date;
  public active: boolean;
  public fields: FieldItem[];

  constructor(values: any) {
    this.id = values.id;
    this.type = values.type;
    this.name = values.name;
    this.description = values.description;
    this.terms = values.terms;
    this.start = values.start ? new Date(values.start) : null;
    this.end = values.end ? new Date(values.end) : null;
    this.active = values.active;
    this.fields = values.fields ?? [];
  }


  isValid(): boolean {
    const now: Date = new Date();
    return this.start <= now && this.end >= now;
  }

  createParticipation(values?: any) {
    const fields = this.fields.map(it => new FieldItem(it));
    return new Participation({...values, fields: fields});
  }
}

export class Participation {
  public email: string;
  public text: string;
  public customerId: string;
  public firstName: string;
  public lastName: string;
  public gender: string;
  public country: string;
  public dressSize: string;
  public shoeSize: string;
  public affiliate: string;
  public fields: FieldItem[];

  public termsAdvertisement: boolean;
  public termsParticipation: boolean;
  public termsPrivacy: boolean;

  constructor(values: any) {
    this.email = values.email || '';
    this.text = values.text || '';
    this.customerId = values.customerId || '';
    this.firstName = values.firstName || '';
    this.lastName = values.lastName || '';
    this.gender = values.gender || '';
    this.country = values.country || '';
    this.dressSize = values.dressSize || '';
    this.shoeSize = values.shoeSize || '';
    this.affiliate = values.affiliate || '';
    this.termsAdvertisement = values.termsAdvertisement || false
    this.termsParticipation = values.termsParticipation || false
    this.termsPrivacy = true;
    this.fields = values.fields ?? [];
  }

  isValid(): boolean {
    const requiredCustomFields = this.fields.filter(it => it.required);
    const customFieldsValid = requiredCustomFields.every(it => it.value != "");
    return (this.email && this.termsParticipation && customFieldsValid);
  }

}

export class ParticipationError {
  public code: number;
  public message: string;

  constructor(code, message) {
    this.code = code;
    this.message = message;
  }
}


